import type { ParagraphDto } from '@zg-rentals/ts-rental-manager-api-client';
import { TextStyledComponentConstructor } from './TextStyledComponent';

const ParagraphStyledComponentConstructor = ({ type = 'paragraph', body = [[]], heading = [] }: ParagraphDto) => ({
  type: String(type),
  body: body.map((b) => b.map((c) => TextStyledComponentConstructor(c))),
  heading: heading.map((h) => TextStyledComponentConstructor(h)),
});

export { ParagraphStyledComponentConstructor };

export type ParagraphStyledComponentProps = ReturnType<typeof ParagraphStyledComponentConstructor>;
